import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';

import {PlatformAuthenticationFormTipCars} from './PlatformAuthenticationFormTipCars';
import {PlatformPhotoSettings} from './PlatformPhotoSettings';
import {PlatformTipCarsInfo} from './PlatformTipCarsInfo';
import {PlatformTipCarsVin} from './PlatformTipCarsVin';

export function PlatformSettingsTipCars() {
  return (
    <>
      <PlatformAuthenticationFormTipCars />
      <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.TIPCARS} />
      <PlatformTipCarsVin />
      <PlatformTipCarsInfo />
    </>
  );
}
